import { useEffect, useState } from "react";

// Devuelve `value` retrasado `delay` ms desde el último cambio.
// Útil para no re-filtrar listas grandes en cada tecla presionada:
// el input queda respondiendo al instante, pero el filtrado real
// (que puede ser costoso) solo corre cuando el usuario deja de escribir.
export const useDebouncedValue = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
